.container {
  padding: 10px 8px;
  background-color: var(--color-primary-blue-900);

  @media screen and (width >= 641px) {
    padding: 12px 16px;
  }

  @media screen and (width >= 1366px) {
    padding: 12px 120px;
  }
}

.inner {
  display: grid;
  gap: 12px;

  @media screen and (width >= 1366px) {
    width: 1125px;
    margin-inline: auto;
  }
}

.hamburger {
  @media screen and (width >= 981px) {
    display: none;
  }
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.topLeft {
  display: flex;
  gap: 8px;
  align-items: center;
}

.logoLink {
  display: flex;
  gap: 12px;
  align-items: center;
}

.logo {
  width: 80px;
  height: 16px;

  @media screen and (width >= 641px) {
    width: 122px;
    height: 24px;
  }
}

.titleText {
  display: none;
  font-size: var(--font-size-xs);
  line-height: 1.2;
  color: #bfc9d7;

  @media screen and (width >= 981px) {
    display: block;
  }
}

.topRight {
  display: flex;
  gap: 16px;
  align-items: center;
  height: 28px;
}

.sp {
  @media screen and (width >= 641px) {
    display: none;
  }
}

.pc {
  @media screen and (width <= 640px) {
    display: none;
  }
}
